import {
  File,
  TransferAPIType,
} from '@wetransfer/transfer/apollo-api/usage/types';
import Helper from '@wetransfer/transfer/helper';
import {
  FileCollection,
  TransferCollection,
} from '@wetransfer/transfer/types/graphql-types';

export function transformFileNodes(files: FileCollection): File[] {
  if (files === undefined) {
    throw new Error('Files should not be undefined');
  }

  return (
    files?.collection.reduce((files, file) => {
      if (file !== undefined && file !== null) {
        const { size, type, id } = file;
        const name = Helper.stripHtmlTags(file.name);

        return [
          ...files,
          {
            id,
            name,
            type,
            size: parseInt(size),
          },
        ];
      }

      return files;
    }, []) ?? []
  );
}

export function transformTransferEdges(
  transfers: TransferCollection
): TransferAPIType[] {
  return transfers.collection.map(
    ({
      createdAt,
      downloadCount,
      expiresAt,
      files,
      id,
      message,
      name,
      from,
      passwordProtected,
      recipients,
      securityHash,
      sender,
      shortenedUrl,
      state,
      totalFileSize,
      uploadedAt,
      paid,
      product,
    }) => {
      return {
        paid,
        createdAt,
        expiresAt,
        totalFilesCount: files.totalCount,
        files: transformFileNodes(files),
        id,
        message,
        name,
        from,
        numberLinkDownloads: downloadCount,
        passwordProtected,
        previewUrl: '',
        recipients: recipients.collection.map(({ downloaded, email }) => ({
          downloaded,
          email,
        })),
        product,
        secret: securityHash,
        sender,
        shortenedUrl,
        state,
        totalFileSize,
        uploadedAt,
      };
    }
  );
}
